import { DraftMenu } from '@larvitu/shared/mui/ui-draft';

import type { FC, PropsWithChildren, ReactElement } from 'react';


export interface LayoutPropsExperimental extends PropsWithChildren {
  header?: ReactElement<{ preview: boolean }>;
  footer?: ReactElement;
  preview?: boolean;
}

export const Layout_experimental: FC<LayoutPropsExperimental> = ( {
  children,
  header: Header,
  footer: Footer,
  preview,
} ) => (
  <>
    {Header}

    <DraftMenu />

    {children}

    {Footer}
  </>
);

export const LayoutNoFooter: FC<LayoutPropsExperimental> = ( {
  children,
  header: Header,
} ) => (
  <>
    {Header}

    {children}
  </>
);
